module.exports = __webpack_public_path__ + "static/media/3.81ab646f.jpg";